var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F73A54",
    d: "M2.901 12.826 3.135.086H.873l.234 12.74zm-.936 5.486c.91 0 1.69-.65 1.69-1.56 0-.936-.78-1.612-1.69-1.612-.884 0-1.638.676-1.638 1.612 0 .91.754 1.56 1.638 1.56"
  })));
};
export default SvgWarningIcon;